function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
// export interface getItemsFromAlgoliaProps {
//   type:string,indexName:string,tags:string[],attribute:string[]
// }

//type: string, indexName: string, tags: string[], attribute: string[]
import algoliasearch from 'algoliasearch';
import { get, canUseDOM } from './index';
import algoliaDefaultSettings from '../algoliaDefaultSettings.json';
// const ALGOLIA_INDEXNAME = 'uat_vd_en';
const buildTagField = (field, value, score) => {
  let fieldFilter = `${field}:${value}`;
  if (score) {
    fieldFilter += `<score=${score}>`;
  }
  return fieldFilter;
};
export const loadCategoryAlgoliaResults = (matchedCategories, algoliaSettings, type, searchCount, tags, curatorTags, filters, ALGOLIA_INDEXNAME, isTagsRule) => {
  return new Promise(resolve => {
    // The field that contains tags to match against
    const tagField = 'tags';
    let ALGOLIA_APPID;
    let ALGOLIA_APIKEY;
    if (canUseDOM) {
      ALGOLIA_APPID = get(algoliaSettings, 'id') || algoliaDefaultSettings.id;
      ALGOLIA_APIKEY = get(algoliaSettings, 'key') || algoliaDefaultSettings.key;
    }
    // How many matches the user has, plus one because the default
    // score for Algolia is 1 on a match so boost above that slightly.
    const matchedCount = matchedCategories.length + 1;

    // Build pieces that will be passed and OR'ed together by Algolia
    const queryPieces = matchedCategories.map((category, index) => {
      const filter = buildTagField(tagField, category, matchedCount - index);
      return filter;
    });

    // Build a fallback condition so we don't filter out anything from queries.
    const fallbackCondition = buildTagField(tagField, '-tag');

    // Init the client and index.
    const client = algoliasearch(ALGOLIA_APPID, ALGOLIA_APIKEY);
    const index = client.initIndex(ALGOLIA_INDEXNAME);

    // Perform a search using the condition
    index.search('', {
      sumOrFiltersScores: false,
      // This tells Algolia to add the filter tag scores together so we get a "total" weight
      getRankingInfo: true,
      // Used to sort client side, highest scored item likely will not be at the top.
      hitsPerPage: searchCount,
      // facetFilters: [...filters, [...queryPieces, fallbackCondition]], // Query filters.
      //  ...filters,
      facetFilters: isTagsRule ? tags : [type, tags, curatorTags, [...queryPieces, fallbackCondition]],
      // Query filters.
      filters
    }).then(response => {
      // Extract the results and do a pass of sorting clientside.
      const {
        hits
      } = response;
      hits.sort((a, b) => b._rankingInfo.filters - a._rankingInfo.filters);
      resolve(hits);
    });
  });
};
const makeCancelable = promise => {
  let hasCanceled_ = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(val => hasCanceled_ ? reject({
      isCanceled: true
    }) : resolve(val));
    promise.catch(error => hasCanceled_ ? reject({
      isCanceled: true
    }) : reject(error));
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
};
const getListing = function (indexName, itemFilters, algoliaSettings, querySearch) {
  let sumOrFiltersScores = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var host = '';
  if (canUseDOM) {
    host = window.location.href.split('#')[0].split('?')[0].substring(window.location.href.split('#')[0].split('?')[0].lastIndexOf('/') + 1);
  }
  return new Promise((resolve, reject) => {
    import('./algolia').then(mod => {
      return mod.default;
    }).then(algoliaModule => algoliaModule.getIndex(indexName, algoliaSettings)).then(index => index.search(typeof querySearch === 'undefined' ? _objectSpread({
      sumOrFiltersScores,
      // This tells Algolia to add the filter tag scores together so we get a "total" weight
      getRankingInfo: true
    }, itemFilters) : querySearch)).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
      // console.error(error);
    });
  });
};
export let cancelableAlgoliaPromise = null;
export const getListingCancelable = function (indexName, itemFilters, algoliaSettings, querySearch) {
  let sumOrFiltersScores = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var host = '';
  if (canUseDOM) {
    host = window.location.href.split('#')[0].split('?')[0].substring(window.location.href.split('#')[0].split('?')[0].lastIndexOf('/') + 1);
  }
  if (cancelableAlgoliaPromise) {
    cancelableAlgoliaPromise.cancel();
  }
  const promise = new Promise((resolve, reject) => {
    import('./algolia').then(mod => {
      return mod.default;
    }).then(algoliaModule => algoliaModule.getIndex(indexName, algoliaSettings)).then(index => index.search(typeof querySearch === 'undefined' ? _objectSpread({
      sumOrFiltersScores,
      // This tells Algolia to add the filter tag scores together so we get a "total" weight
      getRankingInfo: true,
      // Used to sort client side, highest scored item likely will not be at the top.
      ruleContexts: itemFilters.facetFilters ? itemFilters.facetFilters[0] ? itemFilters.facetFilters[0][0] ? [`${itemFilters.facetFilters[0][0].replace('type:', '')}-${host}`] : [`${itemFilters.facetFilters[0][0]}-${host}`] : '' : ''
    }, itemFilters) : querySearch)).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
      // console.error(error);
    });
  });
  cancelableAlgoliaPromise = makeCancelable(promise);
  return cancelableAlgoliaPromise;
};
export default getListing;
export const formatTagsRuleToFilters = tagsRule => {
  let facetsFilters = [];
  if (tagsRule) {
    let parsedTR = JSON.parse(tagsRule);
    if (parsedTR.length) {
      parsedTR.forEach(rule => {
        facetsFilters.push(rule);
      });
    }
  }
  return facetsFilters;
};
export const formatTagsRuleToFiltersOneByOne = (tagsRule, tagsArray) => {
  if (tagsRule) {
    let parsedTR = JSON.parse(tagsRule);
    if (parsedTR.length) {
      parsedTR.forEach(rule => {
        tagsArray.push(rule);
      });
    }
  }
  return tagsArray;
};
export const generateSeeMoreTagsFromRules = tagsRule => {
  let facetsFilters = [];
  if (tagsRule) {
    let parsedTR = JSON.parse(tagsRule);
    if (parsedTR.length) {
      parsedTR.forEach(tagsArray => {
        tagsArray.forEach(rule => {
          facetsFilters.push({
            name: '',
            id: '',
            title: {
              jss: {
                value: rule.replace('tags:', '')
              }
            }
          });
        });
      });
    }
  }
  return facetsFilters;
};
export const isTagsRule = rule => {
  return rule && JSON.parse(rule).length > 0;
};